import React, { FC } from 'react';

import { classes } from './Divider.st.css';

export const Divider: FC<React.PropsWithChildren<unknown>> = () => (
  <div className={classes.root}>
    <div className={classes.divider}></div>
  </div>
);
